var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-49.86 -49.86 598.33 598.33",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -49.86,
    y: -49.86,
    width: 598.33,
    height: 598.33,
    rx: 299.165,
    fill: "#FFC859",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 249.3,
    cy: 76.72,
    rx: 73,
    ry: 72.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 177.388,
    cy: 63.48,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 201.388,
    cy: 44.816,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 164.084,
    cy: 91.488,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 164.084,
    cy: 118.144,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 160.42,
    cy: 139.728,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 153.092,
    cy: 160.408,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 215.42,
    cy: 17.448,
    rx: 17.664,
    ry: 17.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 237.868,
    cy: 19.488,
    rx: 17.664,
    ry: 17.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 321.204,
    cy: 63.48,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 297.204,
    cy: 44.816,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 334.532,
    cy: 91.488,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 334.532,
    cy: 118.144,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 338.188,
    cy: 139.728,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 345.548,
    cy: 160.408,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 283.228,
    cy: 17.448,
    rx: 17.664,
    ry: 17.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 260.748,
    cy: 19.488,
    rx: 17.664,
    ry: 17.448
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC9789"
    },
    points: "450.252,366.408 297.308,319.168 297.308,306.608 201.308,306.608 201.308,319.168 48.356,366.408 57.308,498.608 57.308,498.608 57.308,498.608 441.308,498.608 443.428,498.608 443.428,498.608 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8377"
    },
    points: "450.252,366.408 297.308,319.168 297.308,306.608 201.308,306.608 201.308,319.168 48.356,366.408 103.404,498.608 57.308,498.608 57.308,498.608 441.308,498.608 443.428,498.608 443.428,498.608 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A06660"
    },
    points: "450.252,366.408 297.308,319.168 297.308,305.656 246.236,301.48 244.668,319.168 253.868,366.408 303.164,498.608 57.308,498.608 57.308,498.608 441.308,498.608 443.428,498.608 443.428,498.608 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M353.972,165.472c0,35.344-51.264,64-104.672,64c-53.376,0-104.656-28.656-104.656-64 s51.28-64,104.656-64C302.708,101.472,353.972,130.128,353.972,165.472z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.308,
    y: 218.608,
    style: {
      fill: "#BF8377"
    },
    width: 96,
    height: 112
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8377"
    },
    points: "290.084,311.312 249.308,416.152 199.804,335.424 249.308,285.92 "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A06660"
    },
    points: "297.308,343.808 297.308,218.608 202.284,218.608 281.46,442.96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC9789"
    },
    d: "M324.268,134.128c0,72.24-36.624,137.624-74.944,137.624s-74.96-65.376-74.96-137.624 s36.64-84.288,74.96-84.288S324.268,61.888,324.268,134.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8377"
    },
    d: "M249.324,49.84c38.32,0,74.944,12.048,74.944,84.288s-36.624,137.624-74.944,137.624"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M259.74,45.08c0,0-69.656,53.328,89.92,117.568c0,0,3.064-70.688-23-101.504 c-26.08-30.8-66.44-27-66.44-27L259.74,45.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M284.692,35.968c0,0,64.16,71.112-135.672,132.048c0,0-11.784-75.976,18.984-108.528 c30.76-32.552,85.92-27.144,85.92-27.144L284.692,35.968z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 332.988,
    cy: 284.128,
    r: 4.672
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#744196"
    },
    d: "M196.812,466.152c0,0,70.008-2,119.336-68s51.328-66,78-54.672 c26.664,11.344-25.344-2-18.672,130.672c1.064,21.344-16.672-5.328-16.672-5.328l-81.328,2.656l-39.984,2.488L196.812,466.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#744196"
    },
    d: "M301.804,466.152c0,0-70.008-2-119.336-68s-51.336-66-78-54.672 c-26.664,11.344,25.344-2,18.672,130.672c-1.064,21.344,16.664-5.328,16.664-5.328l81.336,2.656l39.984,2.488L301.804,466.152z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9461AF"
    },
    d: "M387.724,498.608c-20.88-80-56.76-34-138.416-34c-81.664,0-117.536-46-138.416,34H387.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#744196"
    },
    d: "M113.308,498.608h274.416c-20.872-80-56.416-34.496-137.208-34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9461AF"
    },
    d: "M154.3,188.312c-17.384,0-31.504,14.112-31.504,31.504s14.12,31.504,31.504,31.504 c17.4,0,31.504-14.112,31.504-31.504S171.7,188.312,154.3,188.312z M154.3,237.312c-9.648,0-17.496-7.832-17.496-17.504 s7.84-17.504,17.496-17.504c9.664,0,17.504,7.832,17.504,17.504S163.964,237.312,154.3,237.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9461AF"
    },
    d: "M344.3,188.312c-17.384,0-31.496,14.112-31.496,31.504s14.112,31.504,31.496,31.504 c17.4,0,31.504-14.112,31.504-31.504S361.7,188.312,344.3,188.312z M344.3,237.312c-9.648,0-17.504-7.832-17.504-17.504 s7.848-17.504,17.504-17.504c9.664,0,17.504,7.832,17.504,17.504S353.964,237.312,344.3,237.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9461AF"
    },
    d: "M317.692,308.824c0,26.496-30.064,48-67.168,48c-37.096,0-67.168-21.504-67.168-48 c0-26.512,30.072-8,67.168-8C287.628,300.824,317.692,282.312,317.692,308.824z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#744196"
    },
    d: "M317.692,308.824c0,26.496-30.064,48-67.168,48c-37.096,0-67.168-21.504-67.168-48 c0-26.512,30.072,21.328,67.168,21.328C287.628,330.152,317.692,282.312,317.692,308.824z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9461AF"
    },
    points: "303.644,302.152 324.316,262.152 358.316,260.152 349.644,286.152 314.316,300.152 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#744196"
    },
    points: "295.644,324.152 314.316,300.152 356.316,303.48 379.644,325.48 350.316,331.48 313.644,310.152 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 143.068,
    cy: 477.728,
    r: 3.76
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 162.348,
    cy: 477.728,
    r: 3.752
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 181.7,
    cy: 477.728,
    r: 3.76
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 201.02,
    cy: 477.728,
    r: 3.76
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 220.332,
    cy: 477.728,
    r: 3.768
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 239.644,
    cy: 477.728,
    r: 3.752
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 258.988,
    cy: 477.728,
    r: 3.752
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 278.284,
    cy: 477.728,
    r: 3.752
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 297.628,
    cy: 477.728,
    r: 3.752
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 316.924,
    cy: 477.728,
    r: 3.752
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 336.236,
    cy: 477.728,
    r: 3.76
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F476D3"
    },
    cx: 355.548,
    cy: 477.728,
    r: 3.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.454997e9d63631f9bf97d4bd34f36070.svg";
export { ForwardRef as ReactComponent };